import { render, staticRenderFns } from "./ZoomModal.vue?vue&type=template&id=022b50e0&"
import script from "./ZoomModal.vue?vue&type=script&lang=js&"
export * from "./ZoomModal.vue?vue&type=script&lang=js&"
import style0 from "./ZoomModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports